import _ from 'underscore';

function getCompareFunction(prop) {
  if (prop === 'Name' || prop === 'Keyword') {
    return function compare(a, b) {
      let aProp = a[prop],
        bProp = b[prop];

      if (aProp > bProp) {
        return 1;
      } else if (aProp < bProp) {
        return -1;
      }
      return 0;
    };
  } else {
    return function compare(a, b) {
      let aProp = a.AggregateMetric[prop],
        bProp =  b.AggregateMetric[prop];

      if (aProp > bProp) {
        return 1;
      } else if (aProp < bProp) {
        return -1;
      }
      return 0;
    };
  }
}

export function keywordPlannerSortFunc(args) {
  let input = args.input,
    direction = args.direction,
    prop = args.prop;

  _.each(input, (ag) => {
    if (!_.isUndefined(ag.Suggestions) && !_.isNull(ag.Suggestions) && _.isArray(ag.Suggestions)) {
      ag.Suggestions = _.sortByOrder(ag.Suggestions, getCompareFunction(prop), direction);
    }
  });
  input = _.sortByOrder(input, getCompareFunction(prop), direction);

  return input;
}
